var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("v-data-table", {
    staticClass: "v-application--is-ltr",
    attrs: {
      headers: _vm.headers,
      items: _vm.appointments,
      "mobile-breakpoint": "670",
      "items-per-page": 25,
      "server-items-length": _vm.counts,
      loading: _vm.isLoading,
      "show-expand": _vm.isPharmacyRequest || _vm.isCanceledRequest,
      "item-key": "group_id",
      "no-data-text": "Keine Suchergebnisse",
      "loading-text": "Wird geladen...",
      "disable-filtering": "",
      "sort-by": _vm.defaultSortBy,
      "sort-desc": "",
      "footer-props": {
        showFirstLastPage: true,
        showCurrentPage: true,
        itemsPerPageOptions: [5, 10, 25, 50],
        itemsPerPageText: "Zeilen pro Seite",
      },
    },
    on: { "update:options": _vm.onOptionsChange },
    scopedSlots: _vm._u([
      {
        key: "item.data-table-expand",
        fn: function ({ item, isExpanded, expand }) {
          return [
            _vm.isExpandableGroup(item)
              ? _c(
                  "v-btn",
                  {
                    attrs: { icon: "", small: "" },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return expand(!isExpanded)
                      },
                    },
                  },
                  [
                    _c("v-icon", { attrs: { small: "" } }, [
                      _vm._v(
                        _vm._s(
                          isExpanded ? "mdi-chevron-up" : "mdi-chevron-down"
                        )
                      ),
                    ]),
                  ],
                  1
                )
              : _vm._e(),
          ]
        },
      },
      {
        key: "item.date",
        fn: function ({ item }) {
          return [
            _c("span", { class: item.commited && "committed" }, [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.formatDateOnly(item.date)) +
                  "\n        "
              ),
            ]),
            _vm._v(" "),
            _vm.isExpandableGroup(item)
              ? _c("span", { class: item.commited && "committed" }, [
                  _vm._v(
                    "\n            - " +
                      _vm._s(_vm.formatDateOnly(item.group_enddate)) +
                      " (" +
                      _vm._s(item.group_size) +
                      ")\n        "
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              _vm._l(item.available_services, function (service) {
                return _c(
                  "v-chip",
                  {
                    key: service,
                    staticClass: "mr-1 px-2",
                    attrs: {
                      color: _vm.getServiceDetails(service).color,
                      dark: "",
                      small: item.service === service,
                      "x-small": item.service !== service,
                      label: "",
                    },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.getServiceDetails(service).name) +
                        "\n            "
                    ),
                  ]
                )
              }),
              1
            ),
          ]
        },
      },
      {
        key: "item.created",
        fn: function ({ item }) {
          return [
            _c(
              "span",
              {
                class: {
                  "success white--text px-2 py-1 rounded":
                    _vm.isCreatedInLast10Minutes(item.created),
                },
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.isCreatedInLast10Minutes(item.created) ? "NEU - " : ""
                    ) +
                    " " +
                    _vm._s(_vm.formatCreatedRange(item)) +
                    "\n        "
                ),
              ]
            ),
          ]
        },
      },
      {
        key: "item.request_date",
        fn: function ({ item }) {
          return [
            _c(
              "span",
              {
                class: {
                  "success white--text px-2 py-1 rounded":
                    _vm.isCreatedInLast10Minutes(item.request_date),
                },
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.isCreatedInLast10Minutes(item.request_date)
                        ? "NEU - "
                        : ""
                    ) +
                    " " +
                    _vm._s(_vm.$formatDate(item.request_date)) +
                    "\n        "
                ),
              ]
            ),
          ]
        },
      },
      {
        key: "item.last_fb_cancelled_at",
        fn: function ({ item }) {
          return [
            _c(
              "span",
              {
                class: {
                  "success white--text px-2 py-1 rounded":
                    _vm.isCreatedInLast10Minutes(item.last_fb_cancelled_at),
                },
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.isCreatedInLast10Minutes(item.last_fb_cancelled_at)
                        ? "NEU - "
                        : ""
                    ) +
                    " " +
                    _vm._s(_vm.$formatDate(item.last_fb_cancelled_at)) +
                    "\n        "
                ),
              ]
            ),
          ]
        },
      },
      {
        key: "item.assigned_pharmacist",
        fn: function ({ item }) {
          return [
            item.assigned_pharmacist?._id
              ? _c(
                  "a",
                  {
                    attrs: {
                      href: `/pharmacists/${item.assigned_pharmacist._id}`,
                      target: "_blank",
                    },
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(item.assigned_pharmacist.firstname) +
                        " " +
                        _vm._s(item.assigned_pharmacist.lastname) +
                        "\n        "
                    ),
                  ]
                )
              : _vm._e(),
          ]
        },
      },
      {
        key: "item.requested_pharmacist",
        fn: function ({ item }) {
          return [
            item.requested_pharmacist?._id
              ? _c(
                  "a",
                  {
                    attrs: {
                      href: `/pharmacists/${item.requested_pharmacist._id}`,
                      target: "_blank",
                    },
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(item.requested_pharmacist.firstname) +
                        " " +
                        _vm._s(item.requested_pharmacist.lastname) +
                        "\n        "
                    ),
                  ]
                )
              : _vm._e(),
          ]
        },
      },
      {
        key: "item.admin",
        fn: function ({ item }) {
          return [
            item.admin
              ? _c("span", [
                  _vm._v(
                    _vm._s(item.admin.firstname) +
                      " " +
                      _vm._s(item.admin.lastname)
                  ),
                ])
              : _vm._e(),
          ]
        },
      },
      {
        key: "item.pharmacy",
        fn: function ({ item }) {
          return [
            _vm.pharmacyHref(item.pharmacy)
              ? _c(
                  "a",
                  {
                    attrs: {
                      href: _vm.pharmacyHref(item.pharmacy),
                      target: "_blank",
                    },
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.pharmacyLabel(item.pharmacy)) +
                        "\n        "
                    ),
                  ]
                )
              : _c("span", [_vm._v(_vm._s(_vm.pharmacyLabel(item.pharmacy)))]),
          ]
        },
      },
      {
        key: "item.wf_state",
        fn: function ({ item }) {
          return [
            _c(
              "span",
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.translateWfState(item.wf_state)) +
                    "\n            "
                ),
                item.self_assigned
                  ? _c(
                      "v-icon",
                      _vm._g(
                        _vm._b(
                          { attrs: { color: "secondary", size: "20" } },
                          "v-icon",
                          _vm.attrs,
                          false
                        ),
                        _vm.on
                      ),
                      [
                        _vm._v(
                          "\n                mdi-account-check\n            "
                        ),
                      ]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]
        },
      },
      {
        key: "item.actions",
        fn: function ({ item }) {
          return [
            _c("PharmacistsRequests", {
              attrs: {
                appointment: item,
                pharmacy: item.pharmacy,
                assignedPharmacist: item.assigned_pharmacist,
                knownPharmacists: item.pharmacy.known_pharmacists || [],
                numOfRequests: item.pharmacist_requests_count,
              },
            }),
          ]
        },
      },
      {
        key: "expanded-item",
        fn: function ({ headers, item }) {
          return [
            _c(
              "td",
              { staticClass: "pa-0", attrs: { colspan: headers.length } },
              [
                _c(
                  "v-simple-table",
                  {
                    staticClass: "group-appointments-table",
                    attrs: { dense: "" },
                  },
                  [
                    _c("thead", [
                      _c("tr", [
                        _c("th", [_vm._v("Datum")]),
                        _vm._v(" "),
                        _c("th", [_vm._v("Termin angelegt")]),
                        _vm._v(" "),
                        _c("th", [_vm._v("Service")]),
                        _vm._v(" "),
                        _c("th", [_vm._v("Zustand")]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(item.group_appointments, function (appointment) {
                        return _c("tr", { key: appointment._id }, [
                          _c("td", [
                            _vm._v(
                              _vm._s(_vm.formatDateOnly(appointment.date))
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(_vm.$formatDate(appointment.created))
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "td",
                            [
                              appointment.service
                                ? _c(
                                    "v-chip",
                                    {
                                      staticClass: "mr-1 px-2",
                                      attrs: {
                                        color: _vm.getServiceDetails(
                                          appointment.service
                                        ).color,
                                        dark: "",
                                        "x-small": "",
                                        label: "",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            _vm.getServiceDetails(
                                              appointment.service
                                            ).name
                                          ) +
                                          "\n                            "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                _vm.translateWfState(
                                  appointment.wf_state || item.wf_state
                                )
                              )
                            ),
                          ]),
                        ])
                      }),
                      0
                    ),
                  ]
                ),
              ],
              1
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }